import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  group: {
    display: "flex",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: 4,
    overflow: "hidden"
  },
  option: {
    flex: 1,
    padding: "8px 4px",
    fontSize: 13,
    textAlign: "center",
    cursor: "pointer",
    background: "transparent",
    border: "none",
    borderLeft: "1px solid rgba(0, 0, 0, 0.23)",
    color: theme.palette.text.secondary,
    outline: "none",
    "&:first-child": {
      borderLeft: "none"
    },
    "&:hover": {
      backgroundColor: theme.palette.action.hover
    }
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: theme.palette.primary.main
    }
  }
}));

const SegmentedControl = ({ value, options, onChange }) => {
  const classes = useStyles();

  return (
    <div className={classes.group} role="group">
      {options.map(option => {
        const isSelected = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            className={
              isSelected
                ? `${classes.option} ${classes.selected}`
                : classes.option
            }
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
